import React, { useEffect } from "react";
import Chart from "react-apexcharts";
import { Row, Col } from "react-bootstrap";
import * as moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  changeOverviewFilter,
  resetOverviewResponses,
  retrieveOverviewResponses,
} from "../../../../../redux/actions/overview";
import { MoonLoader } from "react-spinners";

import "./style.scss";
import Text from "../../../../library/text";

const Index = () => {
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.overview.fetchResponses.loading);
  const userLoading = useSelector(
    (state) => state.user.fetchUserDetails.loading
  );

  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );
  const filter = useSelector((state) => state.overview.filters.responses);
  const data = useSelector((state) => state.overview.fetchResponses.status);

  const optionsRegular = {
    dataLabels: {
      enabled: true,
      style: {
        fontFamily: "Questrial",
        fontSize: "12px",
      },
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
      active: {
        filter: {
          type: "none",
        },
      },
    },
    labels: ["Ja", "Nei", "Kanskje"],
    legend: {
      show: false,
    },
    fill: {
      colors: ["#1BC5BD", "#F64E60", "#FFA800"],
      opacity: 1,
      pattern: {
        strokeWidth: 20,
        width: 20,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "60%",
        },
      },
    },
  };

  const optionsNone = {
    dataLabels: {
      enabled: false,
      style: {
        fontFamily: "Questrial",
        fontSize: "12px",
      },
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
      active: {
        filter: {
          type: "none",
        },
      },
    },
    tooltip: {
      enabled: false,
    },
    labels: ["Ja", "Nei", "Kanskje"],
    legend: {
      show: false,
    },
    fill: {
      colors: ["#1BC5BD", "#F64E60", "#FFA800"],
      opacity: 1,
      pattern: {
        strokeWidth: 20,
        width: 20,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "60%",
        },
      },
    },
  };

  useEffect(() => {
    if (!userLoading) {
      if (selectedCompany) {
        if (!filter) {
          dispatch(resetOverviewResponses());
          const start = moment(Date.now())
            .set({ hour: 0, minute: 0, second: 0 })
            .unix();
          const end = moment(Date.now())
            .set({ hour: 23, minute: 59, second: 59 })
            .unix();
          dispatch(
            changeOverviewFilter({
              type: "responses",
              filter: { name: "week", range: { start: start, end: end } },
            })
          );
        } else {
          dispatch(
            retrieveOverviewResponses({
              filter: filter,
              companyId: selectedCompany,
            })
          );
        }
      } else {
        dispatch(resetOverviewResponses());
      }
    }
  }, [selectedCompany, filter, userLoading]);

  const renderData = () => {
    if (!loading) {
      if (data && data[0] === 0 && data[1] === 0 && data[2] === 0) {
        return (
          <Chart
            options={optionsNone}
            series={[1, 1, 1]}
            type="donut"
            width={"100%"}
          />
        );
      } else {
        return (
          <Chart
            options={optionsRegular}
            series={data}
            type="donut"
            width={"100%"}
          />
        );
      }
    } else {
      return (
        <div className="loading-container">
          <MoonLoader
            css={"margin: 0 auto;"}
            size={40}
            color={"#123abc"}
            loading={true}
          />
        </div>
      );
    }
  };

  const renderValues = (type) => {
    if (!loading) {
      switch (type) {
        case "yes":
          return data[0] ? data[0] : 0;
        case "no":
          return data[1] ? data[1] : 0;
        case "maybe":
          return data[2] ? data[2] : 0;
        default:
          return 0;
      }
    } else {
      return <MoonLoader size={14} color={"#123abc"} loading={true} />;
    }
  };

  return (
    <div className="responses-details-container">
      <Text>
        En oversikt over respons/hit-rate innenfor spesifisert tidsrom for alle
        lister samlet, som er opprettet.
      </Text>
      <Row className="responses-row">
        <Col className="chart-col text-left my-auto">{renderData()}</Col>
        <Col className="chart-details my-auto">
          <div className="information-container">
            <div className="single-detail">
              <Row className="detail-row">
                <Col className="icon-col my-auto">
                  <div className="icon-container type-yes">
                    <i class="fas fa-smile"></i>
                  </div>
                </Col>
                <Col className="amount-col my-auto">
                  <span className="type">Ja</span>
                  <span className="total">{renderValues("yes")}</span>
                </Col>
              </Row>
            </div>
            <div className="single-detail">
              <Row className="detail-row">
                <Col className="icon-col my-auto">
                  <div className="icon-container type-no">
                    <i class="fas fa-frown"></i>
                  </div>
                </Col>
                <Col className="amount-col my-auto">
                  <span className="type">Nei</span>
                  <span className="total">{renderValues("no")}</span>
                </Col>
              </Row>
            </div>
            <div className="single-detail">
              <Row className="detail-row">
                <Col className="icon-col my-auto">
                  <div className="icon-container type-maybe">
                    <i class="fas fa-meh"></i>
                  </div>
                </Col>
                <Col className="amount-col my-auto">
                  <span className="type">Kanskje</span>
                  <span className="total">{renderValues("maybe")}</span>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Index;
